export default [
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/menu/product/product.vue'),
    meta: {
      pageTitle: 'مدیریت محصول ها',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/product/details',
    name: 'addproduct',
    component: () => import('@/views/menu/product/productdetails.vue'),
    meta: {
      pageTitle: 'ایجاد محصول',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/product/details/:id',
    name: 'updateproduct',
    component: () => import('@/views/menu/product/productdetails.vue'),
    meta: {
      pageTitle: 'ویرایش محصول',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/productcategory',
    name: 'productcategory',
    component: () => import('@/views/menu/product/productcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی های محصول',
      action: 'show',
      resource: 'ProductCategoryManager',
    },
  },
  {
    path: '/productcategory/details',
    name: 'addproductcategory',
    component: () => import('@/views/menu/product/productcategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد دسته بندی محصول',
      action: 'show',
      resource: 'ProductCategoryManager',
    },
  },
  {
    path: '/productcategory/details/:id',
    name: 'updateproductcategory',
    component: () => import('@/views/menu/product/productcategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش دسته بندی محصول',
      action: 'show',
      resource: 'ProductCategoryManager',
    },
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('@/views/menu/product/brand.vue'),
    meta: {
      pageTitle: 'مدیریت برندها',
      action: 'show',
      resource: 'BrandManager',
    },
  },
  {
    path: '/brand/details',
    name: 'addbrand',
    component: () => import('@/views/menu/product/branddetails.vue'),
    meta: {
      pageTitle: 'ایجاد برند',
      action: 'show',
      resource: 'BrandManager',
    },
  },
  {
    path: '/brand/details/:id',
    name: 'updatebrand',
    component: () => import('@/views/menu/product/branddetails.vue'),
    meta: {
      pageTitle: 'ویرایش برند',
      action: 'show',
      resource: 'BrandManager',
    },
  },
  {
    path: '/guaranty',
    name: 'guaranty',
    component: () => import('@/views/menu/product/guaranty.vue'),
    meta: {
      pageTitle: 'مدیریت گارانتی ها',
      action: 'show',
      resource: 'GuarantyManager',
    },
  },
  {
    path: '/guaranty/details',
    name: 'addguaranty',
    component: () => import('@/views/menu/product/guarantydetails.vue'),
    meta: {
      pageTitle: 'ایجاد گارانتی',
      action: 'show',
      resource: 'GuarantyManager',
    },
  },
  {
    path: '/guaranty/details/:id',
    name: 'updateguaranty',
    component: () => import('@/views/menu/product/guarantydetails.vue'),
    meta: {
      pageTitle: 'ویرایش گارانتی',
      action: 'show',
      resource: 'GuarantyManager',
    },
  },
  {
    path: '/color',
    name: 'color',
    component: () => import('@/views/menu/product/color.vue'),
    meta: {
      pageTitle: 'مدیریت رنگ ها',
      action: 'show',
      resource: 'ColorManager',
    },
  },
  {
    path: '/productvariety',
    name: 'productvariety',
    component: () => import('@/views/menu/product/productvariety.vue'),
    meta: {
      pageTitle: 'مدیریت تنوع های محصول',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/productvariety/details',
    name: 'addproductvariety',
    component: () => import('@/views/menu/product/productvarietydetails.vue'),
    meta: {
      pageTitle: 'ایجاد تنوع محصول',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/productvariety/duplicate/:id',
    name: 'duplicateproductvariety',
    component: () => import('@/views/menu/product/productvarietydetails.vue'),
    meta: {
      pageTitle: 'ایجاد تنوع محصول',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/productvariety/details/:id',
    name: 'updateproductvariety',
    component: () => import('@/views/menu/product/productvarietydetails.vue'),
    meta: {
      pageTitle: 'ویرایش تنوع محصول',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/supplier',
    name: 'supplier',
    component: () => import('@/views/menu/product/supplier.vue'),
    meta: {
      pageTitle: 'مدیریت تامین کننده ها',
      action: 'show',
      resource: 'SupplierManager',
    },
  },
  {
    path: '/supplier/details',
    name: 'addsupplier',
    component: () => import('@/views/menu/product/supplierdetails.vue'),
    meta: {
      pageTitle: 'ایجاد تامین کننده',
      action: 'show',
      resource: 'SupplierManager',
    },
  },
  {
    path: '/supplier/details/:id',
    name: 'updatesupplier',
    component: () => import('@/views/menu/product/supplierdetails.vue'),
    meta: {
      pageTitle: 'ویرایش تامین کننده',
      action: 'show',
      resource: 'SupplierManager',
    },
  },
  {
    path: '/productcomment',
    name: 'productcomment',
    component: () => import('@/views/menu/product/productcomment.vue'),
    meta: {
      pageTitle: 'مدیریت نظرها',
      action: 'show',
      resource: 'ProductCommentManager',
    },
  },
  {
    path: '/productquestion',
    name: 'productquestion',
    component: () => import('@/views/menu/product/productquestion.vue'),
    meta: {
      pageTitle: 'مدیریت فیلدهای سفارش',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/productquestion/details',
    name: 'addproductquestion',
    component: () => import('@/views/menu/product/productquestiondetails.vue'),
    meta: {
      pageTitle: 'ایجاد فیلد سفارش',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/productquestion/details/:id',
    name: 'updateproductquestion',
    component: () => import('@/views/menu/product/productquestiondetails.vue'),
    meta: {
      pageTitle: 'ویرایش فیلد سفارش',
      action: 'show',
      resource: 'ProductManager',
    },
  },
  {
    path: '/material',
    name: 'material',
    component: () => import('@/views/menu/product/material.vue'),
    meta: {
      pageTitle: 'مدیریت متریال ها',
      action: 'show',
      resource: 'MaterialManager',
    },
  },
  {
    path: '/material/details',
    name: 'addmaterial',
    component: () => import('@/views/menu/product/materialdetails.vue'),
    meta: {
      pageTitle: 'ایجاد متریال',
      action: 'show',
      resource: 'MaterialManager',
    },
  },
  {
    path: '/material/details/:id',
    name: 'updatematerial',
    component: () => import('@/views/menu/product/materialdetails.vue'),
    meta: {
      pageTitle: 'ویرایش متریال',
      action: 'show',
      resource: 'MaterialManager',
    },
  },
  {
    path: '/phonebrand',
    name: 'phonebrand',
    component: () => import('@/views/menu/product/phonebrand.vue'),
    meta: {
      pageTitle: 'مدیریت برندهای گوشی',
      action: 'show',
      resource: 'PhoneBrandManager',
    },
  },
  {
    path: '/phonemodel',
    name: 'phonemodel',
    component: () => import('@/views/menu/product/phonemodel.vue'),
    meta: {
      pageTitle: 'مدیریت مدل های گوشی',
      action: 'show',
      resource: 'PhoneModelManager',
    },
  },
]
